import { Component, computed, inject, input, output } from '@angular/core';
import { MenuItem } from '@openng/optimus-ui/api';
import { Menu } from '@openng/optimus-ui/menu';
import { TranslateService } from '@ngx-translate/core';
import { FolderPersonObject } from '@libs/types/src/services/object-type/folder/folder-person.object';
import { FolderPersonsStore } from '../folder-persons.store';
import { ButtonComponent } from '../../../../kit/button/button.component';
import { BaseDialogService } from '../../../../kit/base-dialog/base-dialog-service';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import {
    FolderPersonRemoveDialogComponent,
} from '../folder-person-remove-dialog/folder-person-remove-dialog.component';

/**
 * Menu akcí nad jednou osobou ve složce.
 *
 * Akce má i primární osoba - složka jich může mít víc. Server hlídá, že ve složce aspoň jedna
 * primární zůstane, a při odchodu vlastníka přepojí folders.person_id na jinou primární osobu.
 */
@Component({
    selector: 'app-folder-person-actions',
    templateUrl: 'folder-person-actions.component.html',
    providers: [FolderPersonsStore],
    imports: [
        Menu,
        ButtonComponent,
    ],
})
export class FolderPersonActionsComponent {

    public readonly store = inject(FolderPersonsStore);
    private readonly dialogService = inject(BaseDialogService);
    private readonly translate = inject(TranslateService);

    public folderPerson = input.required<FolderPersonObject>();
    public serviceId = input<number | null>(null);
    public disabled = input<boolean>(false);

    /** Osoba se změnila (odebrání, primárnost) - rodič si načte osoby složky. */
    public folderPersonChanged = output<void>();

    protected readonly prefix = 'folder.persons.';

    protected canEdit = this.store.isAllowed('folder.update');

    protected visible = computed(() => !this.disabled() && this.canEdit());

    protected menuItems = computed<MenuItem[]>(() => {
        const isMain = !!this.folderPerson().isMain;

        // datumy pobytu se edituje v dialogu historie pobytů, ne odsud
        return [
            {
                label: this.translate.instant(`${this.prefix}actions.${isMain ? 'unsetMain' : 'setMain'}`),
                icon: isMain ? 'pi pi-star' : 'pi pi-star-fill',
                command: () => this.setMain(!isMain),
            },
            {
                label: this.translate.instant(`${this.prefix}actions.remove`),
                icon: 'pi pi-sign-out',
                command: () => this.openDialog(FolderPersonRemoveDialogComponent, `${this.prefix}actions.remove`),
            },
        ];
    });

    private openDialog(component: any, header: string): void {
        this.dialogService.open(component, {
            header: this.translate.instant(header),
            styleClass: 'p-dialog-width-40',
            data: {
                folderPerson: this.folderPerson(),
                serviceId: this.serviceId(),
            },
        }).onClose.subscribe((changed) => changed && this.folderPersonChanged.emit());
    }

    private async setMain(isMain: boolean): Promise<void> {
        await this.store.api.setMainFolderPerson({ id: this.folderPerson().id, isMain });
        this.folderPersonChanged.emit();
        contentGlobalSuccess.next(`${this.prefix}messages.${isMain ? 'mainSet' : 'mainUnset'}`);
    }

}
